'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var client = require('@apollo/client');
var utilities = require('@apollo/client/utilities');
var subscriptions = require('@apollo/client/link/subscriptions');
var graphqlWs = require('graphql-ws');
var WebSocket = require('ws');
var apolloClientFactory = require('@narvar/nth-apollo-client');
var nthHookContextAnalytics = require('@narvar/nth-hook-context-analytics');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var WebSocket__default = /*#__PURE__*/_interopDefaultLegacy(WebSocket);
var apolloClientFactory__default = /*#__PURE__*/_interopDefaultLegacy(apolloClientFactory);

const baseEventLogInfo = {
  eventComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_CHAT,
  eventFeature: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_CHAT,
  feature: 'chatComponent',
  pageComponent: nthHookContextAnalytics.NarvarEventComponents.NTH_KIT_CHAT
};
async function createApolloClient({
  url,
  logEvent
}) {
  const wsUrl = new URL(url);
  wsUrl.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  let isSocketReconnection = false;
  let connectionRetries;
  const splitLink = client.split(({
    query
  }) => {
    const definition = utilities.getMainDefinition(query);
    if (definition.kind === 'OperationDefinition' && definition.operation === 'subscription') {
      return true;
    }
    if (definition.kind === 'OperationDefinition' && definition.operation === 'mutation' && definition?.name?.kind === 'Name' && definition?.name?.value === 'NewChatMessage') {
      return true;
    }
    return false;
  }, new subscriptions.GraphQLWsLink(graphqlWs.createClient({
    url: wsUrl.toString(),
    shouldRetry: () => true,
    retryAttempts: 5,
    retryWait: async function exponentialBackoff(retries) {
      let retryDelay = 1000;
      connectionRetries = retries;
      for (let i = 0; i < retries; i++) {
        retryDelay *= 2;
      }
      await new Promise(resolve => setTimeout(resolve, retryDelay));
    },
    on: {
      closed: event => {
        // 1006 seems to be the code for when the user navigates away from
        // and back to the page, but there may be others we want to track.
        const errorCode = event && event.code;
        isSocketReconnection = true;
        logEvent({
          ...baseEventLogInfo,
          eventType: nthHookContextAnalytics.NarvarEventTypes.SOCKET_DISCONNECT,
          eventFeature: `The web socket connection has been closed. Event code: ${errorCode}`
        });
      },
      connected: () => {
        // only log successful REconnections, not initial ones
        if (isSocketReconnection) {
          logEvent({
            ...baseEventLogInfo,
            eventType: nthHookContextAnalytics.NarvarEventTypes.SOCKET_CONNECT,
            eventFeature: `The web socket connection has been restored after ${connectionRetries + 1} retry / retries.`
          });
          isSocketReconnection = false;
        }
      }
    },
    webSocketImpl: typeof window !== 'object' ? WebSocket__default["default"] : undefined
  })), new client.HttpLink({
    uri: url.toString()
  }));
  const {
    client: client$1
  } = await apolloClientFactory__default["default"]({
    fetch,
    uri: url.toString(),
    ssrMode: false,
    addTypename: true,
    maxBatch: 20,
    disablePersistedCache: true,
    link: () => splitLink
  });
  return client$1;
}
const useLomaClient = () => {
  const [state, setState] = React.useState({});
  const logEvent = nthHookContextAnalytics.useAnalyticsPost();
  React.useEffect(() => {
    // it is assumed that we are running in a browser since this code is in a useEffect
    const url = new URL('/loma/graphql', document.location.href);
    createApolloClient({
      url,
      logEvent
    }).then(client => setState({
      client
    }), error => setState({
      error
    }));
  }, [logEvent]);
  return state;
};

exports["default"] = useLomaClient;
